import { query } from 'src/utils/request';

// 是否必须关联申请单
export const settingUnitApplyForm = async (data) => {
  return query('/zlb/api/expense/purchase/setting/settingUnitApplyForm', { 
    data,
    method: 'post',
  });
};

// 查询配置
export const getSetting = async (orgId) => {
  return query(`/zlb/api/expense/purchase/setting/getSetting/${orgId}`);
};